/* ==========================================================================
   order-tracking.js — order tracking section
   Ported from the mockup's initTrack(): validates the tracking number, then opens
   the tracking page set in the section ({number} = the tracking number).
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;

  ZC.mount((root) => {
    ZC.$$('[data-order-tracking]', root).forEach((box) => {
      if (!ZC.once(box, 'track')) return;
      const form = ZC.$('[data-track-form]', box);
      if (!form) return;
      const input = ZC.$('input', form);
      const err = ZC.$('[data-err]', form);
      const template = box.dataset.url || '';
      const newTab = box.dataset.newTab !== 'false';

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const n = input.value.replace(/\s+/g, '');
        const ok = /^[A-Za-z0-9-]{6,40}$/.test(n);
        input.setAttribute('aria-invalid', String(!ok));
        if (err) err.textContent = ok ? '' : box.dataset.errNumber;
        if (!ok) { input.focus(); return; }
        const url = template.indexOf('{number}') > -1 ? template.replace('{number}', encodeURIComponent(n)) : template;
        if (newTab) window.open(url, '_blank', 'noopener');
        else window.location.href = url;
      });
      input.addEventListener('input', () => {
        if (input.getAttribute('aria-invalid') === 'true') {
          input.setAttribute('aria-invalid', 'false');
          if (err) err.textContent = '';
        }
      });
    });
  });
})();
